import React, { useState, useEffect } from 'react';
import { X, PhoneCall } from 'lucide-react';

export function VideoModal({ isOpen, videoId, onClose }) {
  const [loadError, setLoadError] = useState(false);

  // Keyboard Escape Key Trap & Focus Management
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !videoId) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/85 backdrop-blur-md" role="dialog" aria-modal="true" aria-label="Student Video Testimonial">
      <div className="relative w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-800 bg-slate-900 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-800 px-6 py-4">
          <span className="text-sm font-semibold text-slate-300">Student Transformation Story</span>
          <button onClick={onClose} aria-label="Close Video Preview" className="rounded-lg p-1 text-slate-400 hover:bg-slate-800 hover:text-white transition cursor-pointer">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Video Iframe Container */}
        <div className="relative aspect-video w-full bg-black">
          {loadError ? (
            <div className="flex flex-col items-center justify-center h-full p-6 text-center space-y-4">
              <p className="text-slate-300 text-sm">Video preview unavailable. Speak directly with Kian to learn more.</p>
              <a href="tel:+14374382820" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold transition">
                <PhoneCall className="h-4 w-4" /> Call Kian Directly: +1 (437) 438-2820
              </a>
            </div>
          ) : (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
              title="Student Testimonial Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onError={() => setLoadError(true)}
              className="h-full w-full border-0"
            />
          )}
        </div>
      </div>
    </div>
  );
}
